export default {
	"Language": "Japonca",
	"system": {
		"homePage": {
			"title1": "Başlık 1",
			"title2": "Başlık 2",
			"description1": "Son 7 gün",
			"description2": "Son 6 ay"
		}
	},
	"login": {
		"register": "Pendaftaran Anggota",
		"usernamePls": "Masukkan nama pengguna Anda",
		"passwordPls": "Masukkan kata sandi Anda",
		"toRegister": "Tidak punya akun? Daftar sekarang",
		"doLogin": "Masuk"
	},
	"register": {
		"repasswordPls": "Masukkan kata sandi penarikan Anda",
		"codePls": "Masukkan kode undangan",
		"register": "Daftar",
		"xieyi": "Saya menyetujui syarat dan ketentuan",
		"xieyiPls": "Silakan pilih protokol pembukaan akun di bawah ini!"
	},
	"mine": {
		"xyfs": "Skor Kredit",
		"ljjf": "Total Poin",
		"recharge": "Isi Poin",
		"withdraw": "Tarik Poin",
		"money": "Poin yang Dimiliki",
		"infomation": "Informasi Dasar",
		"moneylog": "Riwayat Penggunaan Poin",
		"withdrawrecord": "Riwayat Penarikan",
		"gamerecord": "Riwayat Hadiah",
		"notice": "Pengumuman",
		"mymove": "Riwayat Pantauan",
		"loginpwd": "Kata Sandi Masuk",
		"paypwd": "Kata Sandi Penggunaan",
		"loginout": "Keluar",
		"paypwdhasseted": "Kata sandi penarikan tunai telah diatur. Hubungi layanan pelanggan untuk mengubahnya",
		"setbank": "Silakan atur kartu deposit Anda!",
		"lorr": "Masuk / Daftar"
	},
	"infomation": {
		"username": "ID Anggota",
		"name": "Nama Lengkap",
		"bankcard": "Akun Penarikan",
		"phone": "Nomor Ponsel",
		"recharge": "Isi Ulang",
		"amount": "Poin yang Dimiliki",
		"toserve": "Hubungi Layanan Pelanggan",
		"kfms": "Hubungi layanan pelanggan untuk pengisian ulang offline. Beberapa saluran pembayaran mungkin menyertakan desimal acak dalam jumlah pengisian, harap periksa saat pembayaran"
	},
	"withdraw": {
		"title": "Penukaran Poin",
		"log": "Riwayat Penarikan",
		"method": "Metode Penarikan",
		"avmoney": "Poin Tersedia",
		"limit": "Batas Penarikan",
		"submit": "Ajukan Penarikan Poin",
		"xiane": "Batas Per Transaksi",
		"numbers": "Jumlah Penarikan",
		"time": "Waktu Deposit",
		"zuidi": "Minimum",
		"zuigao": "Maksimum",
		"numsmax": "Penarikan Maksimum Harian",
		"ci": "kali",
		"timedetail": "Waktu deposit normal sekitar 5 menit, tercepat 2 menit",
		"bank": "Kartu Bank",
		"status1": "Menunggu",
		"status2": "Penarikan Selesai",
		"status3": "Penarikan Gagal",
		"enterCorrectAmount": "Silakan masukkan jumlah yang valid",
		"selectBankCard": "Silakan pilih kartu bank untuk penarikan",
		"enterPayPassword": "Silakan masukkan kata sandi pembayaran Anda"
	},
	"moneylog": {
		"title": "Detail Poin",
		"type1": "Isi Ulang",
		"type2": "Bonus",
		"type3": "Tugas",
		"type4": "Bonus",
		"type5": "Penarikan Berhasil",
		"type6": "Penarikan Gagal",
		"rechargeNote": "(Isi Ulang)"
	},
	"setting": {
		"loginpwdtitle": "Ubah Kata Sandi Masuk",
		"oldpwd": "Masukkan kata sandi lama Anda",
		"newpwd": "Masukkan kata sandi baru Anda",
		"renewpwd": "Masukkan ulang kata sandi baru Anda",
		"change": "Ubah",
		"plseall": "Kata sandi yang dimasukkan tidak cocok!",
		"pswwrong": "Masukan kata sandi tidak cocok dua kali",
		"paypwdtitle": "Pengaturan Kata Sandi Saldo",
		"paypwd": "Masukkan kata sandi akun penarikan Anda",
		"repaypwd": "Konfirmasi kata sandi",
		"title": "Pengaturan",
		"basicInfo": "Pengaturan Informasi Dasar",
		"loginPassword": "Kata Sandi Masuk",
		"fundPassword": "Kata Sandi Saldo",
		"logout": "Keluar",
		"payPasswordSet": "Kata sandi penarikan telah diatur. Hubungi layanan pelanggan untuk mengubahnya",
		"payPasswordNotSet": "Belum Diatur",
		"payPasswordHasSet": "Telah Diatur",
		"confirm": "Konfirmasi"
	},
	"home": {
		"gonggao": "Nikmati Pengalaman Mewah Kelas Atas",
		"qgkf": "Melayani Seluruh Negeri",
		"hotlist": "Daftar Rekomendasi Populer",
		"hotgame": "Aktivasi Tugas",
		"gaoji": "Premium",
		"smrz": "Verifikasi Identitas Asli",
		"videorz": "Verifikasi Video Pribadi",
		"star": "Peringkat",
		"sg": "Tinggi Badan",
		"xw": "Berat Badan",
		"diqu": "Wilayah yang Dilayani",
		"apply": "Ajukan Janji Temu",
		"ssxz": "Status Waktu Nyata",
		"joinvip": "Menjadi anggota"
	},
	"video": {
		"title": "Video",
		"nums": "Jumlah Tayangan",
		"bofangliang": "Jumlah Tayangan",
		"hotlist": "Rekomendasi Populer",
		"plsrefisrt": "Harap isi ulang untuk menonton video!",
		"trialEnded": "Pratinjau Berakhir",
		"rechargeToWatch": "Anda dapat menonton gratis setelah mengisi ulang",
		"goRecharge": "Isi Ulang Sekarang"
	},
	"choose": {
		"title": "Malam Terbaik",
		"nav": "Profil",
		"apply": "Ajukan Pencocokan",
		"jianjie": "Profil Manajer",
		"move": "Dapat Dipindahkan",
		"click": "Klik untuk konfirmasi",
		"detail": "Detail",
		"videodetail": "Video Langsung"
	},
	"common": {
		"refresh": "Penyegaran berhasil",
		"noallow": "Fitur tidak aktif!",
		"disable": "Tidak Aktif",
		"all": "Semua",
		"nomore": "Tidak ada lagi",
		"nodata": "Tidak ada data",
		"submit": "Kirim",
		"more": "Lihat Lebih Banyak Admin",
		"pinglunnav": "Komentar",
		"pingluntitle": "Komentar Admin",
		"pldtitle": "Detail Komentar",
		"minenav": "Akun Saya",
		"homenav": "Beranda",
		"addbank": "Tambah Kartu Deposit",
		"setbank": "Pendaftaran Akun Penarikan",
		"confirm": "Konfirmasi",
		"cancel": "Batal"
	},
	"game": {
		"expect": "Periode",
		"jieguo": "Data",
		"da": "A",
		"xiao": "B",
		"dan": "C",
		"shuang": "D",
		"大": "A",
		"小": "B",
		"单": "C",
		"双": "D",
		"order": "Spesifikasi Tugas",
		"clear": "Bersihkan Pesanan",
		"submit": "Konfirmasi & Kirim",
		"kjcc": "Kemenangan berhasil, periode:",
		"lxgly": "Konsultasikan dengan admin untuk tugas ini",
		"plsmoney": "Silakan masukkan jumlah!",
		"plsnum": "Silakan pilih nomor!",
		"moneynote": "Saldo tidak mencukupi, hubungi layanan pelanggan untuk isi ulang!",
		"lefttime": "Waktu Tersisa",
		"lunci": "Periode",
		"workRecord": "Riwayat Tugas",
		"day": "Hari",
		"period": "Periode",
		"allWork": "Semua Tugas",
		"reset": "Atur Ulang",
		"confirm": "Konfirmasi",
		"bonusPoints": "Poin Bonus",
		"missionMoney": "Detail Jumlah Tugas",
		"missionResult": "Hasil Tugas",
		"points": "Poin",
		"workPoints": "Poin Tugas",
		"giftCompleted": "Hadiah Selesai",
		"orderTime": "Waktu Pesanan:",
		"detail": "Detail",
		"content": "Konten",
		"amount": "Jumlah",
		"result": "Hasil",
		"time": "Waktu",
		"win": "Menang",
		"missionFailed": "Tugas Gagal"
	},
	"kefu": {
		"title": "Layanan Pelanggan Langsung",
		"lianxi": "Kontak",
		"content": "Layanan 7/24",
		"defaultName": "Layanan Online"
	},
	"setname": {
		"title": "Koreksi Nama Asli",
		"xingming": "Nama",
		"tips": "Demi keamanan akun, nama asli harus sesuai dengan nama pada kartu bank yang terhubung",
		"xmpls": "Masukkan nama asli Anda",
		"save": "Simpan",
		"notreset": "Jangan atur ulang!",
		"plsentername": "Silakan masukkan nama!"
	},
	"withdrawCenter": "Pusat Penarikan",
	"withdrawRecord": "Riwayat Penarikan",
	"withdrawAmount": "Jumlah Penarikan",
	"allMoney": "Semua",
	"singleLimit": "Batas Per Transaksi",
	"lowest": "Terendah",
	"highest": "Tertinggi",
	"withdrawTimes": "Jumlah Penarikan",
	"maxDailyWithdraw": "Maks. Penarikan Harian",
	"times": "kali",
	"arrivalTime": "Waktu Deposit",
	"limitDescription": "Deskripsi Batas",
	"balance": "Saldo",
	"withdrawNow": "Tarik Sekarang",
	"enterCorrectAmount": "Masukkan jumlah yang valid",
	"personalReport": "Laporan Pribadi",
	"profitAmount": "Jumlah Keuntungan",
	"profitFormula": "Rumus Keuntungan: Jumlah Kemenangan - Jumlah Tugas",
	"taskAmount": "Jumlah Tugas",
	"accountOffline": "Akun Offline",
	"loginRegister": "Masuk / Daftar",
	"loginForMore": "Masuk untuk menikmati lebih banyak layanan!",
	"author": "Penulis:",
	"notification": "Notifikasi",
	"changePhone": "Ubah Nomor Ponsel",
	"save": "Simpan",
	"existingPhone": "Nomor Ponsel Saat Ini",
	"newPhone": "Nomor Ponsel Baru",
	"withdrawAccountRegister": "Pendaftaran Akun Penarikan",
	"selectBankCard": "Silakan pilih kartu bank",
	"accountNumber": "Nomor Rekening",
	"enterBankCardNumber": "Masukkan nomor kartu bank",
	"systemNotice": "Notifikasi Sistem",
	"myMovie": "Film Saya",
	"completeTaskForMore": "Selesaikan tugas untuk mendapatkan lebih banyak tiket film",
	"movieTicket": "Tiket Film:",
	"watchList": "Daftar Tontonan",
	"noDataYet": "Belum ada data",
	"setNameFirst": "Silakan atur nama Anda terlebih dahulu sebelum menghubungkan akun penarikan!",
	"setPasswordFirst": "Silakan atur kata sandi penarikan Anda terlebih dahulu sebelum menghubungkan kartu bank!",
	"accountHolder": "Pemilik Rekening",
	"enterRealName": "Masukkan nama asli Anda",
	"withdrawPassword": "Kata Sandi Penarikan",
	"registerWithdrawPassword": "Daftarkan kata sandi penarikan Anda",
	"bankCard": "Kartu Bank",
	"orderContentLabel": "Konten Pesanan:",
	"all": "Semua",
	"bonusPointsLabel": "Poin Bonus",
	"waitingResultLabel": "Menunggu Hasil",
	"missionMoneyDetails": "Detail Jumlah Tugas",
	"points": "Poin",
	"switch": "Sakelar",
	"currentSelection": "Pilihan Saat Ini:",
	"quantity": "Jumlah:",
	"total": "Total",
	"ticketAmount": "Jumlah Tiket",
	"availablePoints": "Poin Tersedia",
	"verify": "Verifikasi",
	"possible": "Mungkin",
	"thumb": "Jempol",
	"privacyPolicy": "Kebijakan Privasi",
	"romanticDescription": "Layanan romantis kami hanya mengizinkan pendaftaran dengan menyelesaikan layanan verifikasi identitas asli atau melalui rekomendasi anggota terverifikasi, untuk melindungi informasi pribadi anggota.",
	"person1": "Xia Yu",
	"person2": "Min Xue",
	"lishijl": "Riwayat Sebelumnya",
};

